import * as React from 'react';

import { Container, Wrapper, TopBar } from 'common/components';
import {
  ContentProvider,
  ContentList,
  FiltersForm,
  Sort,
  SearchInput,
  StatusFilter,
} from 'templates/content';
import { useBadgesList } from '../queries';
import { DetailsSwitch } from 'templates/details';
import appUrls from 'base/app/urls';
import { translate as t } from 'common/utils/translate';
import BadgesDetails from './BadgesDetails';
import { BADGE_TYPE } from 'base/api/types';

const fields = {
  search: 'search',
  sort: 'sort',
  filter: 'filter',
};

const BadgesList = () => {
  const { data, isError } = useBadgesList();

  const context = {
    data: data?.values.map((badge) => {
      return {
        ...badge,
        titleSuffix:
          badge.type === BADGE_TYPE.ITEMS_COMPLETED && badge.criteria?.possible_pks
            ? 'multilevel'
            : null,
      };
    }),
    path: {
      details: appUrls.BADGES.DETAILS,
      list: appUrls.BADGES.LIST,
    },
  };

  return (
    <Container>
      <ContentProvider {...context}>
        <TopBar title={t('Badges')}>
          <FiltersForm
            sort={['title', fields.sort]}
            search={['title', fields.search]}
            filter={['status', fields.filter]}
          >
            <Wrapper margin={[0, 0.5]}>
              <SearchInput name={fields.search} />
            </Wrapper>
            <Wrapper margin={[0, 0.5]}>
              <StatusFilter name={fields.filter} />
            </Wrapper>
            <Wrapper margin={[0, 0.5]}>
              <Sort name={fields.sort} />
            </Wrapper>
          </FiltersForm>
        </TopBar>
        <ContentList isError={isError} />
        <DetailsSwitch>
          <BadgesDetails />
        </DetailsSwitch>
      </ContentProvider>
    </Container>
  );
};

export default BadgesList;
